import { APIClient } from "./axiosClient";

export class UserApi {
    static fetchUsersFromDB(payload: { username: string; roleId: string; pageNumber: number; pageSize: number,sortBy:string,sortOrder:string }) {
        return APIClient(
            '/user/getUsersFromDB',
            payload,
            { requestType: 'post' }
        );
    }

    static getUsersFromDbInCSVFormat(payload: {
        roleId: string;
        username: string;
        pageNumber: number;
        pageSize: number;
    }) {
        return APIClient(
            '/user/getUsersFromDbInCSVFormat',
            payload,
            { requestType: 'post', responseType: 'blob' }
        );
    }

    static createOrUpdateUser(payload: {
        userProfileImage?: File;
        userVO: {
            id?: number;
            username: string;
            name: string;
            roleVO: {
                id: number;
                roleName?: string;
            };
            phoneCountryCode: string;
            phoneNumber: string;
            merchantId?: number;
            merchantStoreId?: number;
            programId?: number | string;
            clientId?: number;
            perkProgramDetails?: {
                programId: number | string;
                programCode: string;
            };
            mfaEnabled: boolean;
            roleId?: number;
            userProfileImageUri?: string;
            skipEmailVerification?: boolean;
            password?: string;
        };
    }) {
        const formData = new FormData();
        
        if (payload.userProfileImage) {
            formData.append('userProfileImage', payload.userProfileImage);
        }

        console.log(payload.userVO,"payload.userVO----")
        
        const userVOBlob = new Blob([JSON.stringify(payload.userVO)], { type: 'application/json' });
        formData.append('userVO', userVOBlob);

        return APIClient(
            '/user/v2/createOrUpdateUser',
            formData,
            { 
                requestType: 'post',
                contentType: 'multipart/form-data'
            }
        );
    }

    static changePassword(payload) {
        return APIClient(
            '/user/changePassword',
            payload,
            { requestType: 'post' }
        );
    }

    static generateMfaQrCode(payload: { username: string }) {
        return APIClient(
            '/user/generateMfaQrCode',
            payload,
            { requestType: 'post' }
        );
    }

    static verifyMfaQrCode(payload: { username: string; mfaCode: string }) {
        return APIClient(
            '/user/verifyMfaQrCode',
            payload,
            { requestType: 'post' }
        );
    }

    static verifyMfa(payload: { username: string; mfaCode: string }) {
        return APIClient(
            '/user/verifyMfa',
            payload,
            { requestType: 'post', withCredentials: true }
        );
    }

    static getUser(payload: { username: string }) {
        return APIClient(
            '/user/getUser',
            payload,
            { requestType: 'post', withCredentials: true }
        );
    }

    static deleteUser(userId: string) {
        return APIClient(
            `/user/deleteUser?userId=${userId}`,
            {},
            { requestType: 'delete' }
        );
    }

    static resendInvitation(payload: { email: string }) {
        return APIClient(
            '/user/resendInvitation',
            payload,
            { requestType: 'post' }
        );
    }
} 
